export default "__VITE_ASSET__DaTHJpfz__"